import React from "react";

import classnames from "classnames";
import { getPlanPackageIdsById, getPayrollLead } from "QuotePage/Selectors";
import { planDetailsURL, planPackageURL } from "QuotePage/urls";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import AnalyticsTracking from "Utils/AnalyticsTracking";
import formatCurrency from "Utils/formatCurrency";
import simplifyPlanName from "Utils/simplifyPlanName";

import { LinkButton } from "Cobalt/Button";
import { Collapse } from "Cobalt/Collapse";
import Stack from "Cobalt/Stack";
import { Table, TR, TD, TH } from "Cobalt/TableV2";
import BodyText from "Common/BodyText";
import Button from "Common/Button";
import { Card, CardSection } from "Common/Card";
import { CarrierLogoFlexbox } from "Common/CarrierLogo";
import { addPackageToCart } from "Common/CartService";
import { isSampleQuote } from "Common/EnterAges/Selectors";
import { Col, Row } from "Common/Grid";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";
import { getPlans } from "Common/PlanLoader/Selectors";
import SICheckbox from "Common/SICheckbox";

import makeBem from "Utils/makeBem";

const ANALYTICS_LOCATION = "expanding_plan_package_card";

export class PlanPackageCardDumb extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.defaultOpen || false,
      includedPlans: props.planPackageIds,
    };
  }

  toggle = () => {
    this.setState({ open: !this.state.open });
  };

  togglePlan = (planId) => {
    if (this.state.includedPlans.includes(planId)) {
      this.setState({
        includedPlans: this.state.includedPlans.filter((pid) => pid != planId),
      });
    } else {
      this.setState({ includedPlans: this.state.includedPlans.concat(planId) });
    }
  };

  handleOfferPlansButtonClicked = (reduxTriggerProps) => () => {
    this.props.onClickOfferPackage(this.state.includedPlans);
    AnalyticsTracking.trackEvent("cta_clicked", {
      location: ANALYTICS_LOCATION,
      base_plan_id: reduxTriggerProps.basePlan.id,
      name: reduxTriggerProps.basePlan.raw_name,
      brand: reduxTriggerProps.basePlan.carrier,
      label: "Offer This Package",
    });
  };

  startApplicationButton = () => {
    if (this.props.payrollLead?.partner) {
      return (
        <LinkButton size="medium" href={`/${this.props.payrollLead}/router/payroll-prospect`}>
          Offer This Package
        </LinkButton>
      );
    }

    return (
      <Button size="medium" onClick={() => this.handleOfferPlansButtonClicked(this.props)()}>
        Offer This Package
      </Button>
    );
  };

  render() {
    const { basePlan, contributionScheme } = this.props;
    if (!basePlan) {
      return null;
    }

    const baseCompanyShare = contributionScheme.ratioSelf * basePlan.average_monthly_premium;

    return (
      <Card theme="flat" p={0} className="w-full" mb={0}>
        <CardSection
          style={{
            display: "flex",
            width: "100%",
            minHeight: "80px",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          className={makeBem("ExpandingPlanCard")("Container")}
          onClick={this.toggle}
        >
          <Div className={classnames("flex-col-4")}>
            <CarrierLogoFlexbox plan={basePlan} maxSize={3} />
          </Div>
          <Div className={classnames("flex-col-4")}>
            <BodyText size="large" weight="bold">
              {basePlan.carrier} {basePlan.plan_type}
            </BodyText>
          </Div>
          <Div className={classnames("flex-col-3")} style={{ textAlign: "right" }}>
            {this.renderPlanCost(basePlan)}
          </Div>
          <Div className={classnames("flex-col-1")} style={{ textAlign: "center" }}>
            <Icon icon={this.state.open ? "angle-up" : "angle-down"} size="2x" />
          </Div>
        </CardSection>
        <Collapse in={this.state.open}>
          {/* This wrapping div is required for collapse to be smooth */}
          <div>
            <CardSection>
              <Table mb={4}>
                <thead>
                  <TR>
                    <TH style={{ textAlign: "center" }}>Offer?</TH>
                    <TH>Plan</TH>
                    <TH>Doctor Visits</TH>
                    <TH>Coverage Details</TH>
                    <TH>Company Cost</TH>
                    <TH>Employee Cost</TH>
                  </TR>
                </thead>
                <tbody>
                  {this.props.planPackageIds.map((p, i) => (
                    <React.Fragment key={i}>
                      {this.props.planPackage.find((plan) => plan.id == p) ? (
                        <TR>
                          <TD style={{ textAlign: "center" }}>
                            {i == 0 ? (
                              "Base"
                            ) : (
                              <SICheckbox
                                checked={this.state.includedPlans.includes(this.props.planPackage.find((plan) => plan.id == p).id)}
                                onChange={this.togglePlan.bind(this, this.props.planPackage.find((plan) => plan.id == p).id)}
                              />
                            )}
                          </TD>
                          <TD>{simplifyPlanName(this.props.planPackage.find((plan) => plan.id == p))}</TD>
                          <TD>{formatCurrency(this.props.planPackage.find((plan) => plan.id == p).estimated_costs.pcp_visit)}</TD>
                          <TD>
                            <Link to={planDetailsURL({ params: { planID: p } })}>More Details</Link>
                          </TD>
                          <TD>{formatCurrency(baseCompanyShare)}</TD>
                          <TD>{formatCurrency(this.props.planPackage.find((plan) => plan.id == p).average_monthly_premium - baseCompanyShare)}</TD>
                        </TR>
                      ) : (
                        this.renderPlanLoading()
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </Table>
              <Stack direction="horizontal" justify="space-between" align="center">
                {this.startApplicationButton()}
              </Stack>
            </CardSection>
          </div>
        </Collapse>
      </Card>
    );
  }

  renderPlanLoading() {
    return (
      <tr>
        <td>
          <Div
            style={{
              height: "20px",
              width: "100%",
              backgroundColor: "#f5f5f5",
            }}
          />
        </td>
        <td>
          <Div style={{ height: "20px", width: "80%", backgroundColor: "#f5f5f5" }} />
        </td>
        <td>
          <Div style={{ height: "20px", width: "80%", backgroundColor: "#f5f5f5" }} />
        </td>
        <td>
          <Div style={{ height: "20px", width: "80%", backgroundColor: "#f5f5f5" }} />
        </td>
        <td>
          <Div style={{ height: "20px", width: "80%", backgroundColor: "#f5f5f5" }} />
        </td>
        <td>
          <Div style={{ height: "20px", width: "80%", backgroundColor: "#f5f5f5" }} />
        </td>
      </tr>
    );
  }

  renderPlanCost(plan) {
    const { isSampleQuote } = this.props;

    let sampleQuoteAsterisk;
    if (isSampleQuote) {
      sampleQuoteAsterisk = <sup>*</sup>;
    }

    const cost = formatCurrency(plan.average_monthly_premium);

    if (!cost) {
      return <Icon icon="cog" spin ml={3} flavor="solid" />;
    }
    return (
      <>
        <BodyText size="large" weight="bold" componentClass="span">
          {cost}
        </BodyText>
        <BodyText size="medium" weight="normal" componentClass="span">
          /mo
        </BodyText>
        <BodyText>per employee{sampleQuoteAsterisk}</BodyText>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const planPackageIds = getPlanPackageIdsById(state, ownProps.planPackage.id);
  const allPlans = getPlans(state);
  const planPackage = planPackageIds.map((planId) => allPlans.find((p) => p.id == planId)).filter((val) => val !== null && val !== undefined);
  const basePlan = planPackage.find((p) => p.id == ownProps.planPackage.id);

  return {
    payrollLead: getPayrollLead(state),
    isSampleQuote: isSampleQuote(state),
    contributionScheme: state.newCostBreakdown.contributionScheme,
    planPackageIds,
    planPackage,
    basePlan,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  onClickOfferPackage: (planIds) => {
    dispatch(addPackageToCart(planIds));
  },
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRouter(withRedux(PlanPackageCardDumb));
